import { css } from 'styled-components';

import { Offering } from '@arrived/models';

export function getQuarterlyAssetUnderManagementFee(offering: Offering) {
  return offering.quarterlyAumFeeAmount ?? Math.round((0.01 * offering.targetRaiseAmount) / 4);
}

export const offeringDetailsListItemPaddingMixin = css`
  padding: ${({ theme }) => theme.spacing(2, 3)};

  &.mobile {
    padding: ${({ theme }) => theme.spacing(1.5, 0)};
  }
`;
